import { onUnmounted } from 'vue'

export const useThrottle = <T extends (...args: any[]) => void>(callback: T, delay: number = 100) => {
    let throttleTimer: NodeJS.Timeout | null = null

    const throttledFunction = (...args: any[]) => {
        if (throttleTimer === null) {
            throttleTimer = setTimeout(() => {
                // eslint-disable-next-line n/no-callback-literal
                callback(...args)
                throttleTimer = null
            }, delay)
        }
    }

    const cleanup = () => {
        if (throttleTimer) {
            clearTimeout(throttleTimer)
            throttleTimer = null
        }
    }

    onUnmounted(cleanup)

    return {
        throttledFunction,
        cleanup,
    }
}
